/**
 * DefaultTable – handles default states for document viewing
 * 
 * Features:
 * - Shows message when no document is selected
 * - Shows message when document type is unsupported
 * - Provides user guidance for document selection
 * 
 * Props expected:
 * - selectedDocument: document data (may be null)
 * - model: document model type (may be null)
 * 
 * Author: Galo Alonso Peralta Espinoza  
 * Date: 04-17-2025
 */

import React from 'react'

// Material UI
import { Typography } from '@mui/material'

// Local CSS
import styles from './DefaultTable.module.css'

/**
 * Default Table Component
 * Handles cases when no document is selected or document type is unsupported
 */
export default function DefaultTable({ selectedDocument, model }) {
  
  // If no document is selected, show default message
  if (!selectedDocument) {
    return (
      <div className={styles.tableContainer}>
        <Typography variant="h6" className={styles.sectionTitle}>
          Document Viewer
        </Typography>
        <div className={styles.messageContainer}>
          <Typography variant="h6" className={styles.messageTitle}>
            Select a Document
          </Typography>
          <Typography variant="body1" className={styles.messageBody}>
            Please select a document from the Inventory to view its data.
          </Typography>
        </div>
      </div>
    )
  }

  // If document is selected but no model, show unsupported message
  if (!model) {
    return (
      <div className={styles.tableContainer}>
        <Typography variant="h6" className={styles.sectionTitle}>
          Document Viewer
        </Typography>
        <div className={styles.messageContainer}>
          <Typography variant="h6" className={styles.messageTitle}>
            Unsupported Document Type
          </Typography>
          <Typography variant="body1" className={styles.messageBody}>
            This document type is not yet supported. Please select a supported document from the Inventory.
          </Typography>
        </div>
      </div>
    )
  }

  // This should never be reached if used properly, but provide fallback
  return (
    <div className={styles.tableContainer}>
      <Typography variant="h6" className={styles.sectionTitle}>
        Document Viewer
      </Typography>
      <div className={styles.messageContainer}>
        <Typography variant="h6" className={styles.messageTitle}>
          Unknown State
        </Typography>
        <Typography variant="body1" className={styles.messageBody}>
          An unexpected state occurred. Please try selecting a document again.
        </Typography>
      </div>
    </div>
  )
} 